export const statusCheckedMappingAll = mappingForm => {
  if (mappingForm.length <= 0) {
    return false;
  } else {
    return !mappingForm.some(data => data?.isChecked !== true);
  }
};
